import Picker from '@emoji-mart/react';
import { useTranslation } from 'react-i18next';

import styles from './EmojiPicker.module.scss';
import { Props } from './EmojiPicker.props';

let emojisData: unknown = null;

async function fetchEmojis() {
  if (emojisData) return emojisData;

  const response = await fetch('/emoji-mart-native-15.json');
  emojisData = response.json();

  return emojisData;
}

const EmojiPicker = ({ visible = true, onClickOutside, onEmoji }: Props) => {
  const { i18n } = useTranslation();

  if (!visible) return null;

  return (
    <div className={styles.emojiPicker}>
      <Picker
        data={fetchEmojis}
        // @ts-expect-error the type is any from the library
        onEmojiSelect={emoji => onEmoji?.(emoji.native)}
        onClickOutside={onClickOutside}
        locale={i18n.language}
        // Disable the search and preview because they are not translated to french.
        searchPosition="none"
        previewPosition="none"
        theme="light"
      />
    </div>
  );
};

export default EmojiPicker;
